/* eslint-disable no-plusplus */
import React, { useMemo, useState } from "react";
import { DatePicker, Popover } from "antd";
import dayjs from "dayjs";
import Button from "../../../../Core/Components/CustomButton";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";

const MoreFarmerFilters = ({ filters, setFilters }) => {
  const [open, setOpen] = useState(false);
  const [moreFilters, setMoreFilters] = useState({
    dateRangeStart: "",
    dateRangeEnd: "",
  });

  const filterCount = useMemo(() => {
    let count = 0;
    if (moreFilters.dateRangeStart && moreFilters.dateRangeEnd) count++;
    return count;
  }, [moreFilters]);

  const hasFieldValues = () => {
    return (
      moreFilters?.dateRangeStart !== "" && moreFilters?.dateRangeEnd !== ""
    );
  };

  const handleDateRangeChange = (e) => {
    if (e && e.length === 2 && e[0] && e[1]) {
      setMoreFilters({
        ...moreFilters,
        dateRangeStart: e[0].format("YYYY-MM-DD"),
        dateRangeEnd: e[1].format("YYYY-MM-DD"),
      });
    }
  };

  const handleClear = () => {
    setMoreFilters({
      dateRangeStart: "",
      dateRangeEnd: "",
    });

    setFilters({
      ...filters,
      dateRangeStart: "",
      dateRangeEnd: "",
    });
  };

  const handleApply = () => {
    setFilters({
      ...filters,
      dateRangeStart: moreFilters.dateRangeStart,
      dateRangeEnd: moreFilters.dateRangeEnd,
    });
  };

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open}
      arrow={false}
      onOpenChange={(state) => setOpen(state)}
      content={
        <div className="overflow-y-auto bg-white w-78 rounded-md p-3 shadow-moreFilters">
          <div className="flex items-center justify-between">
            <div className="text-base font-medium text-new-black font-poppins">
              More filters
            </div>
            <CloseIcon
              className="w-5 h-5 cursor-pointer stroke-dark-grey-text"
              onClick={() => setOpen(false)}
            />
          </div>
          <div className="mt-6">
            <div className="font-light font-poppins text-xs leading-4.5 text-dark-grey-text mb-2">
              Date Range
            </div>
            <DatePicker.RangePicker
              value={[
                moreFilters.dateRangeStart !== "" &&
                  dayjs(moreFilters.dateRangeStart),
                moreFilters.dateRangeEnd !== "" &&
                  dayjs(moreFilters.dateRangeEnd),
              ]}
              format="DD MMM YYYY"
              separator={<div className="text-dark-grey-text"> - </div>}
              onCalendarChange={(e) => handleDateRangeChange(e)}
              allowClear={false}
              className="h-[39px]"
              disabledDate={(current) => current.isAfter(dayjs())}
            />
          </div>

          <div className="flex mt-6 gap-x-3">
            <Button
              size="primary"
              width="save"
              colors="grey"
              modifier={hasFieldValues() ? null : "blur"}
              disabled={!hasFieldValues()}
              onClick={() => {
                setOpen(false);
                handleClear();
              }}
            >
              Clear All
            </Button>
            <Button
              size="primary"
              width="save"
              type="submit"
              modifier={hasFieldValues() ? null : "blur"}
              disabled={!hasFieldValues()}
              onClick={() => {
                setOpen(false);
                handleApply();
              }}
            >
              Apply Filters
            </Button>
          </div>
        </div>
      }
    >
      {filterCount > 0 ? (
        <div className="flex items-center gap-x-3">
          <button
            type="button"
            className="px-3 py-[11px] bg-green rounded-md flex items-center gap-x-3 h-10"
          >
            <p className="font-poppins text-xs text-background-white">
              Filters
            </p>
            <div className="w-4.5 h-4.5 rounded-full flex items-center justify-center bg-background-white">
              <p className="text-10 font-aileron text-black font-semibold">
                {filterCount}
              </p>
            </div>
          </button>
          <button
            type="button"
            className="px-3 py-[11px] rounded-md hover:bg-background h-10"
            onClick={() => {
              handleClear();
            }}
          >
            <p className="font-poppins text-xs text-black font-medium">
              Clear All
            </p>
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="flex items-center gap-x-3 px-3 py-[11px] hover:bg-background rounded-md h-10"
        >
          <img src="/assets/icons/sort.svg" alt="Filters" />
          <p className="font-poppins text-xs leading-5 font-medium text-dark-gray">
            More Filters
          </p>
        </button>
      )}
    </Popover>
  );
};

export default MoreFarmerFilters;
